export const architecturalEnvironmentDesignConst = {
  path: "/single-programs/architectural-environment-design",
  title: "ФАКУЛЬТЕТ ИСКУССТВА И ДИЗАЙНА – ДИЗАЙН АРХИТЕКТУРНОЙ СРЕДЫ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Дизайн архитектурной среды — визуализируй и воплощай</h2>
      <p>
        Это направление — на стыке архитектуры, урбанистики и художественного мышления. Программа готовит специалистов, которые умеют
        проектировать гармоничную, функциональную и эстетически выразительную среду: от интерьеров и общественных пространств до элементов
        городской инфраструктуры.
      </p>
      <p>Вы научитесь не просто рисовать, а создавать решения, которые влияют на восприятие и качество жизни людей.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Архитектурное проектирование и визуализация</li>
        <li>Графический и цифровой дизайн</li>
        <li>Интерьеры жилых и общественных пространств</li>
        <li>Урбанистическое проектирование</li>
        <li>Ландшафтная архитектура</li>
        <li>История и теория архитектуры и дизайна</li>
        <li>Материаловедение и светотехника</li>
        <li>Проектная практика и портфолио</li>
      </ul>
      <p>
        Программа строится на сочетании креативных заданий и технических навыков — с использованием современных программ (AutoCAD, SketchUp,
        Adobe, Rhino, Revit и др.)
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Дизайнер архитектурной среды</li>
        <li>Архитектор-дизайнер</li>
        <li>Специалист по проектированию городской среды</li>
        <li>Художник по пространственным решениям</li>
        <li>Консультант по дизайну интерьеров и пространств</li>
        <li>Куратор проектов благоустройства</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €75,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с признанием в арт- и дизайн-сообществе</li>
        <li>Практико-ориентированная программа с портфолио на выходе</li>
        <li>Учёба на русском или английском языке</li>
        <li>Стажировки в архитектурных бюро и дизайнерских студиях Европы</li>
        <li>Индивидуальная поддержка креативных проектов</li>
        <li>Гибкая форма обучения — очно или онлайн</li>
      </ul>
      <p>Твори пространство, в котором хочется жить</p>
      <p>
        Наши студенты создают проекты, меняющие городскую среду, участвуют в конкурсах и выставках, получают приглашения на стажировки уже
        во время обучения.
      </p>
      <br />
      <p className="padding-left">
        «Дизайн архитектурной среды — это форма визуального диалога с обществом. Мы учим говорить на этом языке уверенно и стильно.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия помогает на всех этапах: от выбора специализации до зачисления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Дизайн архитектурной среды — визуализируй и воплощай
    Это направление — на стыке архитектуры, урбанистики и художественного мышления. Программа готовит специалистов, которые умеют проектировать гармоничную, функциональную и эстетически выразительную среду: от интерьеров и общественных пространств до элементов городской инфраструктуры.
    Вы научитесь не просто рисовать, а создавать решения, которые влияют на восприятие и качество жизни людей.
    Что вы будете изучать?
    • Архитектурное проектирование и визуализация
    • Графический и цифровой дизайн
    • Интерьеры жилых и общественных пространств
    • Урбанистическое проектирование
    • Ландшафтная архитектура
    • История и теория архитектуры и дизайна
    • Материаловедение и светотехника
    • Проектная практика и портфолио
    Программа строится на сочетании креативных заданий и технических навыков — с использованием современных программ (AutoCAD, SketchUp, Adobe, Rhino, Revit и др.)
    Кем можно работать после окончания?
    • Дизайнер архитектурной среды
    • Архитектор-дизайнер
    • Специалист по проектированию городской среды
    • Художник по пространственным решениям
    • Консультант по дизайну интерьеров и пространств
    • Куратор проектов благоустройства
    Зарплата в Европе: от €45,000 до €75,000 в год
    Почему выбирают нас?
    • Европейский диплом с признанием в арт- и дизайн-сообществе
    • Практико-ориентированная программа с портфолио на выходе
    • Учёба на русском или английском языке
    • Стажировки в архитектурных бюро и дизайнерских студиях Европы
    • Индивидуальная поддержка креативных проектов
    • Гибкая форма обучения — очно или онлайн
    Твори пространство, в котором хочется жить
    Наши студенты создают проекты, меняющие городскую среду, участвуют в конкурсах и выставках, получают приглашения на стажировки уже во время обучения.
    «Дизайн архитектурной среды — это форма визуального диалога с обществом. Мы учим говорить на этом языке уверенно и стильно.»
    Как поступить?
    Приёмная комиссия помогает на всех этапах: от выбора специализации до зачисления.
`,
};
